import React from "react";
import { Link } from "react-router-dom";

export default function Ticker({ items = [] }) {
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <div className="bg-r24-red text-white flex items-stretch overflow-hidden" data-testid="breaking-news-ticker">
      <div className="bg-black text-white font-head font-bold uc text-sm px-4 flex items-center gap-2 shrink-0 z-10">
        <span className="w-2 h-2 bg-r24-red rounded-full animate-pulse" />
        <span className="hidden sm:inline">Breaking</span>
        <span className="sm:hidden">Live</span>
      </div>
      <div className="flex-1 overflow-hidden flex items-center">
        <div className="marquee">
          {loop.map((a, i) => (
            <Link key={i} to={`/article/${a.slug}`} className="inline-flex items-center font-semibold text-sm px-6 py-2 hover:underline">
              <span className="w-1.5 h-1.5 bg-white rounded-full mr-3" />
              <span className={a.language === "hi" ? "lang-hi" : ""}>{a.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
